import React from "react";
import { Box, Divider, Typography } from "@mui/joy";
import { TopStats, RightSidebar, ProjectRoadmap } from "./components";
import LeadDistribution from "./components/LeadDistribution";
import ProjectMonthly from "./components/ProjectMonthly";

export default function DashboardV2() {
    return (
        <Box
            sx={{
                width: "100%",
                bgcolor: "background.body",
            }}
        >
            <Box
                sx={{
                    width: "100%",
                    display: "flex",
                }}
            >
                <Box flex={1}>
                    <Box
                        sx={{
                            width: "100%",
                            borderBottom: "1px solid",
                            borderColor: "divider",
                            bgcolor: "background.body",
                            display: "flex",
                            alignItems: "center",
                            flex: 1,
                        }}
                    >
                        <TopStats />
                    </Box>

                    <Box
                        sx={{
                            p: 3,
                            display: "flex",
                            flexDirection: "column",
                            gap: 3,
                        }}
                    >
                        <ProjectRoadmap />
                    </Box>
                </Box>

                <Divider orientation="vertical" />
                <Box
                    sx={{
                        minWidth: "25rem",
                        overflowY: "auto",
                        bgcolor: "background.surface",
                        maxWidth: "25rem",
                    }}
                >
                    <RightSidebar />
                </Box>
            </Box>
            <Divider />
            <Box sx={{ p: 3 }} display={"flex"} gap={3}>
                <LeadDistribution />
                <Divider orientation="vertical" />
                <ProjectMonthly />
            </Box>
            <Divider />
            <Box
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
                p={2}
            >
                <Typography level="body-sm">
                    Dashboards powered by Roofin Motion
                </Typography>
                <Typography level="title-sm">v12.3.2</Typography>
            </Box>
        </Box>
    );
}
